// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3Lzi3","title":"AfterFrontImage_title__14vpn"};